import { render, staticRenderFns } from "./RelatoryNeighborhood.vue?vue&type=template&id=37a84dae&scoped=true"
import script from "./RelatoryNeighborhood.vue?vue&type=script&lang=js"
export * from "./RelatoryNeighborhood.vue?vue&type=script&lang=js"
import style0 from "./RelatoryNeighborhood.vue?vue&type=style&index=0&id=37a84dae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a84dae",
  null
  
)

export default component.exports